<template>
  <div>
    <div>
      <spinner v-if="busy" />
      <selling-grid v-if="view == 'grid'" :handle="handle" :products="products" @product-selected="trackItemSelected"/>
      <n-space align="center" justify="center" style="margin: 15px" vertical>
        <n-spin v-if="nextPageLoading" size="large"/>
      </n-space>
    </div>
  </div>
</template>


<script lang="ts" setup>
import type {ProductDetails} from "~/models/product";
import {NSpace, NSpin} from "naive-ui"
import {useProductsListStore} from "~/store/productsList";
import {storeToRefs} from "pinia";

const {handle} = defineProps<{
  handle: string
}>()

const store = useProductsListStore()
const {
  nextPageLoading,
  view,
  page,
  products,
  hasNextPage,
  busy,
} = storeToRefs(store)
const {fetchProducts, reset} = store


const {arrivedState} = useScroll(document, {throttle: 100, behavior: 'smooth'})
onMounted(async () => {
  await reset()
})
watch(arrivedState, async (state) => {
  if (state.bottom && hasNextPage.value && !busy.value) {
    page.value += 1
    await fetchProducts()
  }
})

store.handle = handle

const trackItemSelected = (payload: { product: ProductDetails }) => {
  const {product} = payload
  useTrackEvent('select_item', {
    item_list_id: handle,
    item_list_name: handle,
    currency: product.price.currency,
    value: product.price.amount / 100,
    items: [{
      item_id: product.id,
      item_name: product.title,
      item_brand: product.shop,
      price: product.price.amount / 100,
    }]
  })
}

</script>

<style scoped>
.dir {
  color: #FAFAFA
}
</style>
